import React, { useState } from 'react';
import { isArrayWithLength } from '@/helpers';
import { Col } from 'antd';
import { Checkbox } from 'antd';
import { StyledCheckboxWrapper } from './styled';
import { StyledModalBodyRow, LoadingModalContent, NoModalContent } from '../ModalBody';
import '@/styles/app.css'

const ProcedureCheckboxes = ({ project, procedures: { data, dataLoaded, error }, onSelectProcedure }) => {
  const [selectedValues, setSelectedValues] = useState([]);

  if (error) {
    return <NoModalContent message='Error loading procedures - close and try again.' />;
  }

  if (project === null) {
    return <NoModalContent message='Select a project to view procedures.' />;
  }

  if (!dataLoaded) {
    return <LoadingModalContent />;
  }

  if (!isArrayWithLength(data)) {
    return <NoModalContent message='No procedures for project.' />;
  }

  const handleCheckboxChange = (values) => {
    const selectedData = data.filter(item => values.includes(item.procedureIdLegacy));
    setSelectedValues(values);
    onSelectProcedure(selectedData);
  };

  return (
    <StyledModalBodyRow>
      <Checkbox.Group
        onChange={handleCheckboxChange}
        value={selectedValues}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <Col>
          <StyledCheckboxWrapper>
            {data.map((procedure) => (
              <div key={procedure.procedureIdLegacy}>
                <Checkbox key={procedure.procedureIdLegacy} className='custom-checkbox' value={procedure.procedureIdLegacy}>
                  P-{procedure.procedureAlphaId ?? procedure.procedureNumber}
                </Checkbox>
                <div>
                  {procedure.procedureTitle}
                </div>
                <div
                  data-toggle="tooltip"
                  title={procedure.procedureExplanation}
                >
                  {procedure.procedureExplanation}
                </div>
              </div>
            ))}
          </StyledCheckboxWrapper>
        </Col>
      </Checkbox.Group>
    </StyledModalBodyRow >
  );
};

export default ProcedureCheckboxes;